<div class="theme-picker-container">
  <div class="theme-picker p-4 bg-white rounded-4 shadow-lg">

    <!-- Card Preview with Demo Info -->
    <div class="preview mb-4 p-4 rounded-3 shadow-sm"
         [style.background]="'linear-gradient(135deg,' + startColor + ',' + endColor + ')'"
         [style.color]="textColor">

      <div class="top d-flex align-items-center mb-3">
        <div class="avatar rounded-circle me-3">JD</div>
        <div class="name-title">
          <h5 class="fw-bold mb-1">John Doe</h5>
          <p class="fw-semibold mb-1">Software Engineer</p>
          <p class="mb-0 small">Development Department</p>
        </div>
      </div>

      <hr class="divider" style="border-color: rgba(255,255,255,0.3)">

      <div class="middle small">
        <p class="mb-1"><strong>Email:</strong> demo"&#64;"example.com</p>
        <p class="mb-1"><strong>Phone:</strong> +1 234 567 8900</p>
        <p class="mb-1"><strong>WhatsApp:</strong> +1 234 567 8900</p>
        <p class="mb-1"><strong>Address:</strong> 123 Demo Street, Demo City</p>
      </div>

      <div class="bottom mt-3 text-end small fw-semibold">
        https://digivcards.ai
      </div>
    </div>

    <!-- Color Selection -->
    <div class="color-selection d-flex flex-wrap justify-content-center gap-3 mb-3">
      <div class="color-button-wrapper text-center">
        <button mat-stroked-button
                [color]="selectedColorType === 'start' ? 'primary' : ''"
                (click)="selectColor('start')">
          Start Color
          <span class="color-dot" [style.background]="startColor"></span>
        </button>
        <input class="hex-input mt-2" type="text" [(ngModel)]="startColor" maxlength="7" placeholder="#RRGGBB">
      </div>

      <div class="color-button-wrapper text-center">
        <button mat-stroked-button
                [color]="selectedColorType === 'end' ? 'primary' : ''"
                (click)="selectColor('end')">
          End Color
          <span class="color-dot" [style.background]="endColor"></span>
        </button>
        <input class="hex-input mt-2" type="text" [(ngModel)]="endColor" maxlength="7" placeholder="#RRGGBB">
      </div>
    </div>

    <!-- Single Color Picker -->
    <div class="color-picker-wrapper text-center mb-4">
      <chrome-picker [(color)]="currentColor" (colorChange)="onColorChange($event)"></chrome-picker>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons d-flex justify-content-end gap-3 flex-wrap">
      <button mat-stroked-button color="warn" (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="isSaving" (click)="apply()">Save</button>
    </div>

  </div>
</div>
